import './index.scss'
import {SunOutlined} from "@ant-design/icons";
import {Button, Dropdown, Flex} from "antd";
import {Header} from "antd/es/layout/layout";
import {useDispatch, useSelector} from "react-redux";
import {changeThemeMode} from "../../store/slice/themeSlice";
import {authData} from "../../store/slice/authSlice";
import {useNavigate} from "react-router-dom";
import {BsMoon} from "react-icons/bs";
import i18n from 'i18next';
import {useTranslation} from 'react-i18next';
import {MdExitToApp} from "react-icons/md";

const AppHeader = () => {
    const {systemMode}=useSelector(state => state.theme)
    const {data:{user}}=useSelector(state => state.auth)
    const {t} = useTranslation();
    const dispatch=useDispatch()
    const navigate=useNavigate()

    const logOut =() => {
        localStorage.removeItem('token')
        localStorage.removeItem('refToken')
        dispatch(authData({
            user: null,
            isLoading: false,
            isAuthenticated: false
        }))
        navigate('/login')
    }
    const isDarkHandle=()=>{
        dispatch(changeThemeMode())
    }

    const languageItems = [
        {
            key: 'uz',
            label: t('uzbek_latin'),
            onClick: () => i18n.changeLanguage('uz')
        },
        {
            key: 'uz_cyrl',
            label: t('uzbek_cyrillic'),
            onClick: () => i18n.changeLanguage('kr')
        },
        {
            key: 'ru',
            label: t('russian'),
            onClick: () => i18n.changeLanguage('ru')
        }
    ];

    return (
        <Header className={'app-header'}>
            <Flex style={{width:90 ,height:70 }} align={"center"} justify={"center"}>
                <img className={'logo'}
                     src='/Logo_.png'
                     alt="logo"
                     style={{width:'100%', height:'100%', objectFit: "contain"}}
                />
            </Flex>
            <Flex align={"center"} gap={10}>
                <Button onClick={isDarkHandle} >
                    {
                        systemMode==='light'?
                            <BsMoon className={'icon'} style={{fontSize:16}} />:
                            <SunOutlined className={'icon'} style={{fontSize:16}}/>
                    }
                </Button>
                <Dropdown menu={{ items: languageItems }} placement="bottomRight">
                    <Button>{t('language')}</Button>
                </Dropdown>
                <UserAccount user={user} logOut={logOut}  />
            </Flex>
        </Header>
    );
};

export default AppHeader;

export const UserAccount = ({ logOut}) => {
    const {t} = useTranslation();

    const items = [
        {
            key: '2',
            label: (
                <div onClick={logOut} style={{display:"flex", justifyContent:"center" , alignItems:"center" , width:'100%' , height:'100'}}>
                    <MdExitToApp style={{fontSize:16}} />
                </div>
            ),
        },
    ];

    return(
        <Dropdown menu={{ items }} placement="topRight" className={'userDropdown'}  arrow>
            <Button style={{display:"flex", justifyContent:"center" , alignItems:"center" , width:'100%' , height:'100'}}>
                {t('logout')}
            </Button>
        </Dropdown>
    )
}